import { FC } from "react";
import { Breadcrumbs, Anchor } from "@mantine/core";
import clsx from "clsx";
import Link from "next/link";

interface TBreadcrumbsProps {
  breadcrumbs?: { title?: string; href?: string }[];
}

const TBreadcrumbs: FC<TBreadcrumbsProps> = ({ breadcrumbs }) => {
  // Canonical breadcrumb style — Bricolage Grotesque, uppercase, wide
  // tracking, fluid clamp. Treats breadcrumbs like an eyebrow / nav
  // label rather than body copy, so it sits comfortably above the hero
  // title without competing with it.
  const baseClass =
    "whitespace-normal break-words font-bricolage-grotesque text-[clamp(0.6875rem,0.25vw+0.625rem,0.8125rem)] font-medium uppercase tracking-[0.18em] transition-colors duration-200";

  return (
    <Breadcrumbs
      className="mb-6 flex-wrap gap-y-1 md:mb-8"
      classNames={{
        root: "text-white/80",
        separator: "mx-2.5 text-white/40 md:mx-3",
      }}
    >
      {breadcrumbs?.length &&
        breadcrumbs?.map(
          (item, index) =>
            item?.title &&
            (item?.href ? (
              <Anchor
                component={Link}
                href={item.href}
                key={index}
                className={clsx(
                  baseClass,
                  index === breadcrumbs.length - 1
                    ? "text-yellow-400"
                    : "text-white/70 hover:text-white",
                )}
              >
                {item.title}
              </Anchor>
            ) : (
              <span
                key={index}
                className={clsx(
                  baseClass,
                  index === breadcrumbs.length - 1
                    ? "text-yellow-400"
                    : "text-white/70",
                )}
              >
                {item.title}
              </span>
            )),
        )}
    </Breadcrumbs>
  );
};

export default TBreadcrumbs;
